import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';
import { erroreOli } from './api';

// Annullare (ritiro o controllo) richiede sempre il motivo: resta visibile nel registro
export const AnnullaDialog = ({ open, titolo, descrizione, onConferma, onClose }) => {
  const [motivo, setMotivo] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setMotivo(''); }, [open]);

  const conferma = async () => {
    setBusy(true);
    try {
      await onConferma(motivo.trim());
      onClose();
    } catch (e) {
      toast.error(erroreOli(e, 'Annullamento non riuscito'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="oli-annulla-dialog">
        <DialogHeader>
          <DialogTitle>{titolo}</DialogTitle>
          <DialogDescription>{descrizione}</DialogDescription>
        </DialogHeader>
        <Textarea value={motivo} onChange={(e) => setMotivo(e.target.value)} rows={3}
          placeholder="Motivo (es. registrato due volte per errore)" data-testid="oli-annulla-motivo" />
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose} data-testid="oli-annulla-chiudi">Indietro</Button>
          <Button onClick={conferma} disabled={busy || motivo.trim().length < 3}
            className="bg-red-600 hover:bg-red-700 text-white" data-testid="oli-annulla-conferma">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Annulla con motivo'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
